module.exports = __webpack_public_path__ + "img/moneybag.c520abb1.png";